import React, { Component } from 'react'
import Activity from "framework/containers/Activity"

//redux
import { connect } from 'react-redux'
import { mapStateToProps, mapDispatchToProps } from 'framework/utils/Redux'

class RestaurantOrderActivity extends Component {

	constructor(props){
		super(props)
		this.RenderedComponent = import("app/components/Restaurant/RestaurantOrder/RestaurantOrderBrowser")
	}

	render() {
		return (
			<Activity 
				name="RestaurantOrder"
				RenderedComponent={this.RenderedComponent}
			/>
		)
	}
}

export default connect(mapStateToProps,mapDispatchToProps)(RestaurantOrderActivity)
